import axios from 'axios'
import config from '../config'
import { getDoctorToken } from "../utils"

const getPatientDropdownListApi = async (params) => {

    let param_name = " ";
    
    if(params.name!="")
    {
        param_name = params.name 
    }

    const response = await axios({
        url: `${config.api.base_url}patient/byname/${param_name}`,
        method: "get",
        // params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default getPatientDropdownListApi